import { render, staticRenderFns } from "./BwLoader.vue?vue&type=template&id=85a6cee2&scoped=true&"
import script from "./BwLoader.vue?vue&type=script&lang=js&"
export * from "./BwLoader.vue?vue&type=script&lang=js&"
import style0 from "./BwLoader.vue?vue&type=style&index=0&id=85a6cee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a6cee2",
  null
  
)

export default component.exports